import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { OD_ICONOS } from 'src/app/services/odoo/odoo-iconos';

/** Ícono SVG lineal del módulo Odoo: <od-icon name="check" [size]="16"></od-icon>. Toma el color del texto. */
@Component({
  selector: 'od-icon',
  template: `<svg viewBox="0 0 24 24" [attr.width]="size" [attr.height]="size" aria-hidden="true" focusable="false" [innerHTML]="html"></svg>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OdIconComponent {
  html: SafeHtml = '';
  private _name = '';
  @Input() size = 14;
  @Input() set name(n: string) {
    this._name = n;
    // Contenido propio y estático (OD_ICONOS), nunca del usuario: es seguro marcarlo como confiable.
    this.html = this.san.bypassSecurityTrustHtml(OD_ICONOS[n] || '');
  }
  get name(): string { return this._name; }
  constructor(private san: DomSanitizer) {}
}
